import { useLingui } from '@lingui/react/macro';

import {
  FilterCheckboxItem,
  FiltersList,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import IconWorld from '@/icons/World.svg';

import {
  ROLE_LIST_SCOPE_KEYS,
  type RoleListScopeKey,
  useRoleListScopeLabels,
} from '../../scope-labels';
import { useFilters } from '../FiltersState';

export const FiltersScope = () => {
  const { t } = useLingui();
  const scopeLabels = useRoleListScopeLabels();

  const {
    scopes: { scopes, setScopes },
  } = useFilters();

  const toggleScope = (scope: RoleListScopeKey) => {
    if (scopes.includes(scope)) {
      setScopes(scopes.filter((s) => s !== scope));
    } else {
      setScopes([...scopes, scope]);
    }
  };

  const options = ROLE_LIST_SCOPE_KEYS.map((id) => (
    <FilterCheckboxItem key={id} id={id} label={scopeLabels[id]} />
  ));

  return (
    <FiltersSubMenu
      id="scope"
      icon={<IconWorld />}
      label={t({
        id: 'settings.organization.roles.filters.scope.label',
        message: 'Scope',
      })}
      count={scopes.length}
    >
      <FiltersList
        ariaLabel={t({
          id: 'settings.organization.roles.filters.scope.label',
          message: 'Scope',
        })}
        values={scopes}
        onChange={toggleScope}
      >
        {options}
      </FiltersList>
    </FiltersSubMenu>
  );
};
